import { render, staticRenderFns } from "./MuiLink.vue?vue&type=template&id=1a329ac0&scoped=true"
import script from "./MuiLink.vue?vue&type=script&lang=js"
export * from "./MuiLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a329ac0",
  null
  
)

export default component.exports